module.exports = __webpack_public_path__ + "static/media/IMG_9509.3b103734.JPG";